import { useStyleParams } from '../contexts/style-params-context';
import { getIsBorderStyleBottom, getIsBorderStyleNone, getTextInputTheme } from './text-input-field/utils';
import { useConfig } from '../contexts/config-context';
export function useTpaStyleParams() {
  const {
    isMobile
  } = useConfig();
  const styleParams = useStyleParams();
  const inputTheme = getTextInputTheme(styleParams, Boolean(isMobile));
  const isBorderStyleBottom = getIsBorderStyleBottom(styleParams, Boolean(isMobile));
  const isBorderStyleNone = getIsBorderStyleNone(styleParams, Boolean(isMobile));
  return {
    inputTheme,
    isBorderStyleNone,
    isBorderStyleBottom
  };
}
//# sourceMappingURL=use-tpa-style-params.js.map